import httpRequest from "services/httpRequest";

const prefix = "/api/custom-field";

export const getCustomFieldPage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: { ...params },
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};
export const getCustomFieldDetails = async id => {
  const result = await httpRequest({
    url: `${prefix}/${id}`,
    method: "GET",
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};
export const onCreateCustomField = async body => {
  return await httpRequest({
    url: `${prefix}`,
    method: "POST",
    data: body,
    successMessage: "toast.create_success",
  });
};

export const onUpdateCustomField = async (id, params) => {
  return await httpRequest({
    url: `${prefix}/${id}`,
    method: "PUT",
    data: params,
    successMessage: "toast.update_success",
  });
};

export const onDeleteCustomField = async id => {
  return await httpRequest({
    url: `${prefix}/${id}`,
    method: "DELETE",
    successMessage: "toast.delete_success",
  });
};

export const onGetAllCustomField = async params => {
  return await httpRequest({
    url: `${prefix}/all/${params}`,
    method: "GET",
  });
};
